/**
 * @file
 * Views component behaviors.
 *
 * @param {object} Drupal - The Drupal object.
 * @param {Function} once - The once function.
 */

(function (Drupal, once) {
  'use strict';

  /**
   * Behavior to initialize htmx on Views AJAX content.
   *
   * When Views loads content via AJAX (such as pagination), htmx needs to
   * process the new DOM elements to make hx-get and other attributes work.
   *
   * @type {object}
   */
  Drupal.behaviors.viewsHtmxInit = {
    attach: function (context) {
      // Check if htmx is available
      if (typeof window.htmx !== 'undefined') {
        // Process any elements with htmx attributes in the new context
        const htmxElements = context.querySelectorAll('[hx-get], [hx-post], [hx-put], [hx-patch], [hx-delete]');
        if (htmxElements.length > 0) {
          // Process the context to initialize htmx on new elements
          window.htmx.process(context);
        }
      }
    }
  };

  /**
   * Behavior for Views Better Exposed Filters.
   *
   * @type {object}
   */
  Drupal.behaviors.viewsFilters = {
    attach: function (context) {
      once('views-filters', '.views-exposed-form', context).forEach((form) => {
        const breakpointValue = (window.getComputedStyle(
          document.documentElement
        )).getPropertyValue('--breakpoint-tablet');

        if (!breakpointValue) {
          return;
        }

        const breakpoint = window.matchMedia(
          `(min-width: ${breakpointValue})`
        );

        const detailsElements = form.querySelectorAll('details.bef--secondary');

        const onWindowResize = () => {
          detailsElements.forEach(details => {
            details.open = details.open && breakpoint.matches;
          });
        };

        // Set initial state
        onWindowResize();

        // Listen for resize events
        window.addEventListener('resize', onWindowResize);

        // Listen for orientation changes on mobile devices
        if (screen.orientation) {
          screen.orientation.addEventListener('change', onWindowResize);
        }
      });
    }
  };
})(Drupal, once);
